import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { DesignationHatch } from "react-migration/domains/constraints/components/Hatch";
import { SourceStatus } from "react-migration/domains/constraints/designation/components/SourceStatus";
import { useDesignationById } from "react-migration/domains/constraints/designation/hooks/useDesignationById";
import { LayerTypeSelectionHeaderProps } from "react-migration/layouts/map/Multilayer/types";
import { DesignationSubTitle, DesignationTitle } from "../../../../designations/Designation";
import {
  getDesignationFillColour,
  getDesignationLineColour,
} from "react-migration/domains/constraints/designation/style/accessors";

export function DesignationSelectionHeader({ selection }: LayerTypeSelectionHeaderProps) {
  const { designation, loading } = useDesignationById(selection.id);
  const fillColor = designation && getDesignationFillColour(designation);
  const lineColor = designation && getDesignationLineColour(designation);

  return (
    <>
      {loading && (
        <div className="relative h-10" data-testid="designation-header-loading">
          <SkeletonLoading rows={1} showPadding={false} />
        </div>
      )}

      {designation && (
        <div className="flex flex-col gap-2 text-sm" data-test-id="designation-header">
          <div className="flex flex-col gap-2">
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-2">
                <div className="mt-1 shrink-0">
                  <DesignationHatch
                    id={designation.sub_category_id}
                    fillColorOverride={fillColor}
                    lineColorOverride={lineColor}
                  />
                </div>
                <div>
                  <DesignationTitle designation={designation} />
                  <DesignationSubTitle designation={designation} />
                </div>
              </div>
              <div>
                <SourceStatus status={designation.source.status} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
